// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PhotosUploadScreen":"qv_a big_ea big_qt big_a big_w"};